import React, { useCallback } from 'react';
import { BaseAIGeneratorDrawer, BulkEmailDetails } from 'features/ai-generators';
import { useBaseGeneratorForm } from 'features/ai-generators/components/BaseAIGeneratorDrawer/hooks/useBaseGeneratorForm';
import strings from 'strings';
import EmptyPlaceholder from 'UI/components/templates/EmptyPlaceholder';
import { UIStatus } from 'UI/constants/status';
import { SvgNotEnoughData } from 'UI/res';

import { PLAIN_STYLES } from '../../styles';

/**
 * Presentational drawer for the bulk email AI generator. Receives its data/handlers from
 * `useBulkAIGenerator` (see `BulkAIGeneratorDrawer.hooks.js`) and is rendered directly by the
 * consuming form. The consumer is responsible for gating on `isAIDrawerOpen`.
 */
export const BulkAIGeneratorDrawer = ({
  buttonDefinitions,
  entity,
  entityResult,
  pluralEntity,
  searchProject,
  onClickGenerate,
  onClickRateButton,
  onClose
}) => {
  const renderErrorComponent = useCallback(data => {
    if (data.status !== UIStatus.Error) return null;
    if (!data.error?.message) return null;

    return (
      <EmptyPlaceholder
        title={strings.bulkEmails.emailGenerator.notEnoughData.title}
        subtitle={data.error.message}
        style={PLAIN_STYLES.notEnoughData}
        customEmptyState={<SvgNotEnoughData size={400} />}
      />
    );
  }, []);

  return (
    <BaseAIGeneratorDrawer
      autoGenerationConfig={{
        enabled: true,
        immediate: true
      }}
      footerExtraButtons={buttonDefinitions}
      formHook={useBaseGeneratorForm}
      isFormEnabled
      leftContent={
        <BulkEmailDetails
          entity={entity}
          entityResult={entityResult}
          pluralEntity={pluralEntity}
          searchProject={searchProject}
        />
      }
      onClickGenerate={onClickGenerate}
      onClickRateButton={onClickRateButton}
      onClose={onClose}
      renderErrorState={renderErrorComponent}
      submitButtonName={strings.ai.generators.actions.regenerate}
      title={strings.bulkEmails.emailGenerator.title}
    />
  );
};
